import { useLanguageValue } from '@ipc/ipc-core';
import React from 'react';
import LanguageSwitcher from '../../common/LanguageSwitcher';
import AuthInfo from '../../common/AuthInfo';
import ipcLogoSmall from '../../../images/ipc_logo_small.png';

export const AppHeaderRightContainer = () => {
  const [{ currentLanguage }] = useLanguageValue();
  return (
    <div className="header-right-container">
      <AuthInfo />
      <img
        className="logo"
        alt="IPC logo"
        src={ipcLogoSmall}
      />
      <LanguageSwitcher currentLanguage={currentLanguage} />
    </div>
  );
};

export default AppHeaderRightContainer;
